import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="filter"
export default class extends Controller {
  static targets = ["loader", "query"];

  connect() {
    this.submitTimer = null;
  }

  start() {
    this.show();
  }

  stop() {
    this.hide();
  }

  show() {
    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.remove("hidden");
      this.loaderTarget.classList.add("flex");
    }
  }

  hide() {
    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.add("hidden");
      this.loaderTarget.classList.remove("flex");
    }
  }

  disconnect() {
    this.clearTimer();
  }

  submitIfReady(event) {
    const query = event.target.value.trim();

    this.clearTimer();

    if (query.length === 0 || query.length >= 2) {
      this.scheduleSubmit();
    }
  }

  scheduleSubmit() {
    this.submitTimer = setTimeout(() => {
      this.element.requestSubmit();
    }, 300);
  }

  clearTimer() {
    if (this.submitTimer) {
      clearTimeout(this.submitTimer);
      this.submitTimer = null;
    }
  }
}
